import React from "react";

/**
 * Renders "Autonomous Risk Governance Operating Vault" with A·R·G·O·V
 * initial letters emphasised (bolder + accent color), spelling out ARGOV.
 * Accepts optional `color` (initials) and `base` (rest) overrides.
 */
export const ARGOVAcronym = ({ color = "#0891b2", base = "inherit", weight = 800 }) => {
  const cap = { color, fontWeight: weight };
  const rest = { color: base, fontWeight: 400 };
  return (
    <span style={{ letterSpacing: "0.01em" }}>
      <span style={cap}>A</span><span style={rest}>utonomous</span>{" "}
      <span style={cap}>R</span><span style={rest}>isk</span>{" "}
      <span style={cap}>G</span><span style={rest}>overnance</span>{" "}
      <span style={cap}>O</span><span style={rest}>perating</span>{" "}
      <span style={cap}>V</span><span style={rest}>ault</span>
    </span>
  );
};
